import { lazy, Suspense, useEffect, useState } from 'react'

import { useSession } from '@/shared/services/session/compat'

import { clientEnv } from '@/env.client'

import { isDebugPanelEligible } from './eligibility'
import { isDebugPanelDisabled } from './storage'

const DebugOverlay = lazy(() =>
  import('./DebugOverlay').then(m => ({ default: m.DebugOverlay }))
)

export function DebugPanelRoot() {
  const { status, data: session } = useSession()
  const [mountOverlay, setMountOverlay] = useState(false)

  const fastPath =
    import.meta.env.DEV || clientEnv.NEXT_PUBLIC_VERCEL_ENV === 'preview'

  useEffect(() => {
    if (isDebugPanelDisabled()) {
      setMountOverlay(false)
      return
    }

    if (fastPath) {
      setMountOverlay(true)
      return
    }

    if (status === 'loading') return

    setMountOverlay(
      isDebugPanelEligible({
        dev: import.meta.env.DEV,
        vercelEnv: clientEnv.NEXT_PUBLIC_VERCEL_ENV,
        sessionStatus: status,
        email: session?.user?.email
      })
    )
  }, [fastPath, status, session?.user?.email])

  if (!mountOverlay) return null

  return (
    <Suspense fallback={null}>
      <DebugOverlay />
    </Suspense>
  )
}
